import { createFileRoute } from "@tanstack/react-router";
import KirtanFinder from "../KirtanFinder";

export const Route = createFileRoute("/")({
  component: KirtanFinder,
});
